// extracted by mini-css-extract-plugin
module.exports = {"form":"addProvider_form__FNNCI","form-control":"addProvider_form-control__41DJi","title":"addProvider_title__2qjOS","error":"addProvider_error__1IEG7"};